import { BaseWebComponentDataProviderFactory } from '../../../../framework/BaseWebComponentDataProviderFactory';
import { API_TYPE_GZ } from '../../../../webcomponents.constants';
import { InProductTrialsAppGzDataProvider } from '../dataProvider/InProductTrialsAppGzDataProvider';

export class InProductTrialsAppDataProviderFactory extends BaseWebComponentDataProviderFactory {
  constructor() {
    super();
    this.map.set(API_TYPE_GZ, InProductTrialsAppGzDataProvider);
  }
}
